import React from "react";
import "./style.scss";

import { defaultProps } from "./props/defaultProps";
import { propTypes } from "./props/propTypes";

import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
    </Box>
  );
}

const LinearWithValueLabel = (props) => {
  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgressWithLabel value={props.timestamp} />
    </Box>
  );
};

export default LinearWithValueLabel;

LinearWithValueLabel.defaultProps = defaultProps;
LinearWithValueLabel.propTypes = propTypes;
